const CAROUSEL_SELECTOR = '[data-carousel]';
const SCROLLER_SELECTOR = '[data-carousel-scroller]';
const PREV_SELECTOR = '[data-carousel-prev]';
const NEXT_SELECTOR = '[data-carousel-next]';

/** Sub-pixel tolerance for scrollLeft vs max scroll */
const SCROLL_EPS = 2;

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const getStep = (scroller) => {
  const firstItem = scroller.querySelector(':scope > *');
  if (!(firstItem instanceof HTMLElement)) {
    return scroller.clientWidth;
  }

  const itemRect = firstItem.getBoundingClientRect();
  if (!itemRect.width) return scroller.clientWidth;

  const styles = window.getComputedStyle(scroller);
  const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

  return itemRect.width + gap;
};

const scrollByStep = (scroller, direction) => {
  const left = getStep(scroller) * direction;
  const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
  scroller.scrollBy({ left, behavior });
};

const updateNavButtons = (scroller, prev, next) => {
  const maxScroll = scroller.scrollWidth - scroller.clientWidth;
  const { scrollLeft } = scroller;

  const canScroll = maxScroll > SCROLL_EPS;
  const atStart = scrollLeft <= SCROLL_EPS;
  const atEnd = scrollLeft >= maxScroll - SCROLL_EPS;

  if (prev instanceof HTMLButtonElement) {
    prev.disabled = !canScroll || atStart;
  }
  if (next instanceof HTMLButtonElement) {
    next.disabled = !canScroll || atEnd;
  }
};

const initCarousel = (root) => {
  if (!(root instanceof HTMLElement)) return;
  if (root.dataset.carouselNavBound === 'true') return;

  const scroller = root.querySelector(SCROLLER_SELECTOR);
  if (!(scroller instanceof HTMLElement)) return;

  const prev = root.querySelector(PREV_SELECTOR);
  const next = root.querySelector(NEXT_SELECTOR);

  const updateNav = () => updateNavButtons(scroller, prev, next);

  let ticking = false;
  scroller.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateNav();
        ticking = false;
      });
    },
    { passive: true }
  );

  window.addEventListener('resize', updateNav, { passive: true });

  if (prev instanceof HTMLButtonElement) {
    prev.addEventListener('click', () => scrollByStep(scroller, -1));
  }
  if (next instanceof HTMLButtonElement) {
    next.addEventListener('click', () => scrollByStep(scroller, 1));
  }

  updateNav();
  root.dataset.carouselNavBound = 'true';
};

const initCarousels = (scope = document) => {
  const carousels = scope.querySelectorAll(CAROUSEL_SELECTOR);
  for (const carousel of carousels) {
    if (!(carousel instanceof HTMLElement)) continue;
    initCarousel(carousel);
  }
};

initCarousels();

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  if (!(section instanceof HTMLElement)) return;
  initCarousels(section);
});